import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
  ];

  return { tableColumns };
};

export default configTable;
